// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

interface ISendRealisationTime {
  studentId: string;
  quizzId: string;
  realisationTime: number;
}

// Define a service using a base URL and expected endpoints
export const studentQuizzApi = createApi({
  reducerPath: "studentQuizzApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["QUIZ"],
  endpoints: (builder) => ({
    sendRealisationTime: builder.mutation<any, ISendRealisationTime>({
      query: (body) => {
        return {
          url: `/quizz/student/realisationTime`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["QUIZ"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSendRealisationTimeMutation } = studentQuizzApi;
